import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    eventId: String,
    eventData: Object
  };
  connect() {
    console.debug("Dispatching: ", this.eventIdValue);
    document.dispatchEvent(new CustomEvent(this.eventIdValue, { detail: this.eventDataValue }));
  }
}
